module.exports = __webpack_public_path__ + "img/example-qr-search-image.ef6417a1.svg";